import { Component, EventEmitter, OnInit, Output, signal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MareAuthService } from '@mare-common/ngx-mare-auth';
import { MareLoaderModule, MareLoaderService } from '@mare-common/ngx-mare-loader';
import { filter, take } from 'rxjs';
import { JsonDataService } from '../services/json-data.service';
import { LandingService } from '../services/landing.service';
import { RoutingService } from '../services/routing.service';
import { CommonModule } from '@angular/common';
import { kpi } from '../dashboard/dashboard-components/dashboard-playmetrics/kpi.enum';
import { EventInteractionService } from '@mare-common/ngx-mare-common';
import { TranslateModule } from '@ngx-translate/core';
import { CompanyDataErrorComponent } from '../dashboard/dashboard-components/company-data-error/company-data-error.component';
import { HelpInlineComponent } from '../shared/help-inline/help-inline.component';

@Component({
  selector: 'app-bolletta',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    MareLoaderModule,
    CompanyDataErrorComponent,
    HelpInlineComponent
  ],
  templateUrl: './bolletta.component.html',
  styleUrls: ['./bolletta.component.scss']
})
export class BollettaComponent implements OnInit {

  test_token = 'UozOm5KKBeRfIVLr5RBhZ91u7gOvDicN5w0XUvpJFqysJLlum8SimmLCpLe6bb3yClOks5LxHaaOARLSYjASk55wCHK7sgsp0tk3iAvRAjVhNwSclSYgxXPPltS8xSlY';
  token!: string;
  kpiMap: any;
  table1: any;
  table2: any;
  table3: any;
  table4: any;

  areas: string[] = [
    "partners",
    "resources",
    "activities",
    "value_proposition"
  ];

  areaMap: any = {
    partners: "Partners",
    resources: "Resources",
    activities: "Activities",
    value_proposition: "Value Proposition"
  };

  loadingBolletta$ = signal<boolean>(true);
  bollettaAnalizingErrors$ = signal<string[]>([]);
  hasBolletta$ = signal<boolean>(false);



  constructor(
    private jsonDataService: JsonDataService,
    private loaderService: MareLoaderService,
    private route: ActivatedRoute,
    private router: Router,
    private routingService: RoutingService,
    private landingService: LandingService,
    private mareAuthService: MareAuthService,
    private eventInteractionService: EventInteractionService
  ) {
    // this.test_token = 'yjFG8iF9XlvOXCJ7Cbikq8KyX1RtgSFrxFztVnqLgKV9geal64FAvMum1WFxpmRAgioHMQUXMI0KeSi8SwfFo8H7oHBoEq9rNbTVYD30hM5fuRzQS5P3Omny2YQloTUJ';
    this.test_token = 'UozOm5KKBeRfIVLr5RBhZ91u7gOvDicN5w0XUvpJFqysJLlum8SimmLCpLe6bb3yClOks5LxHaaOARLSYjASk55wCHK7sgsp0tk3iAvRAjVhNwSclSYgxXPPltS8xSlY';
  }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.loaderService.hideLoader();
      this.token = params['token'] ?? this.test_token;
      if (this.token) {
        this.getKpiMapJson().pipe(take(1)).subscribe((res: any) => {
          this.kpiMap = res;
        });

        this.getBollettaData(this.token).finally(() => {
          this.loadingBolletta$.set(false);
          this.eventInteractionService.publishData({ event: 'bollettaComplete' });
        });

      } else {
        // qui manca il token o non è valido e dobbiamo gestire il redirect alla landing in home Delfi
        this.loaderService.hideLoader();
      }
    });
  }

  getKpiMapJson() {
    return this.jsonDataService.getJsonData('kpi_map.json');
  }

  translateKpi(kpi: any, key: 'title' | 'description' | 'short_description' | 'action' | 'format' = 'title') {
    if (!this.kpiMap) {
      this.getKpiMapJson().pipe(
        take(1)
      ).subscribe((res: any) => {
        this.kpiMap = res;
        return this.kpiMap[kpi][key];
      })
    } else {
      return this.kpiMap[kpi][key];
    }
  }

  getObjectiveMap() {
    return {
      "1": {
        id: 1,
        obiettivoRaggiunto: "Costi di produzione",
        key: 'profitAndLoss.totalCostOfProduction',
        percentage: 5
      },
      "2": {
        id: 2,
        obiettivoRaggiunto: "Aumento dei ricavi",
        key: 'profitAndLoss.operatingRevenues',
        percentage: 7
      },
      "3": {
        id: 3,
        obiettivoRaggiunto: "Costi del personale",
        key: 'profitAndLoss.totalPayrollAndRelatedCosts',
        percentage: 15
      },
      "4": {
        id: 4,
        obiettivoRaggiunto: "Costi di approvvigionamento",
        key: 'profitAndLoss.purchaseOfGoods',
        percentage: 5
      }
    }
  }

  getBollettaData(token: string): Promise<any> {
    return this.landingService.getBollettaFull(token).then((res: any) => {
      console.log('res', res);
      /** TODO
      *
      gestire risposta in errore 404 com messaggio o con contact form o con redirect in home delfi
      */
      if (res && res.deepmatrix !== false) {
        this.hasBolletta$.set(true);
        this.table1 = this.arrangeTable1(res);
        this.table2 = this.arrangeTable2(res);
        this.table3 = this.arrangeTable3(res);
        this.table4 = this.arrangeTable4(res);
        console.log(this.table1, this.table2, this.table3, this.table4);
      } else {
        this.hasBolletta$.set(false);
        this.bollettaAnalizingErrors$.set(['Dati finanziari mancanti']);

      }
    }).catch((err) => {
      console.error(err);
    });


  }

  arrangeTable1(data: any) {
    const areas: any = {
      partners: [],
      resources: [],
      activities: [],
      value_proposition: []
    };

    // Mappa le aree ai nomi degli oggetti nel JSON
    const areaMap: any = {
      partners: "partners",
      resources: "resources",
      activities: "activities",
      value_proposition: "value_proposition"
    };

    // Itera su ogni area per cercare i KPI con stato "ko"
    for (let area in areaMap) {
      const kpiData = data.deepmatrix.company_vs_average[areaMap[area]];
      if (kpiData) {
        // Filtra i KPI con stato "ko" e aggiungili all'area corrispondente
        const kpiKo = kpiData.filter((kpi: any) => kpi.status === 'ko').map((kpi: any) => ({
          kpi: kpi.kpi,
          title: this.translateKpi(kpi.kpi, 'title'),
          action: this.translateKpi(kpi.kpi, 'action'),
          value: kpi.value,
          description: this.translateKpi(kpi.kpi, 'description'),
        }));

        // Aggiungi i KPI alla rispettiva area
        if (kpiKo.length > 0) {
          areas[area].push({
            kpis: kpiKo,
            suggestions: data.deepmatrix.improvement_suggestions[area]
          });
        }
      }
    }

    return areas;
  }

  arrangeTable2(data: any) {
    const result: any = [];

    // Mappa le aree ai nomi degli oggetti nel JSON
    const areaMap: any = {
      partners: "partners",
      resources: "resources",
      activities: "activities",
      value_proposition: "value_proposition"
    };

    // Itera su ogni area per cercare i KPI con stato "ko"
    for (let area in areaMap) {
      const kpiData = data.deepmatrix.company_vs_average[areaMap[area]];
      const productData = data.kpiList[areaMap[area]]?.products;

      if (kpiData && productData) {
        // Filtra i KPI con stato "ko"
        const kpiKo = kpiData.filter((kpi: any) => kpi.status === 'ko');

        // Itera sui KPI "ko"
        kpiKo.forEach((kpi: any) => {
          const products = productData || {}; // Evita errori se non ci sono prodotti nell'area
          let totalPrice = 0;
          const descriptions: any = [];
          const skus: any = [];

          // Calcola la somma dei prezzi dei prodotti e raccoglie le descrizioni
          for (let productId in products) {
            if (!productId && productId.trim().length <= 0) {
              continue;
            }
            const product = products[productId];

            if (product.product_price) {
              totalPrice += parseFloat(product.product_price) || 0;
            } else {
              continue;
            }

            if (product.descrizione_azione) {
              descriptions.push(product.descrizione_azione);
            }
            skus.push(product.product_sku);
          }

          // Aggiungi il risultato per questo KPI
          result.push({
            kpi_name: kpi.kpi,
            title: this.translateKpi(kpi.kpi, 'title'),
            action: this.translateKpi(kpi.kpi, 'action'),
            descriptions: descriptions.length > 0 ? descriptions : ["Nessuna descrizione"],
            skus: skus.length > 0 ? skus : ["Nessun SKU"],
            total_price: totalPrice
          });
        });
      }
    }

    return result;
  }

  arrangeTable3(payload: any) {
    const table3: any = {
      totalInvestment: 0,
      realInvestment: 0,
      objectives: {
      }
    };
    let totalInvestment = 0;
    // let realInvestment = 0;

    let areas = [];
    // table3.objectives = payload.areas;

    for (const keyA in payload.areas) {
      if (!keyA || keyA.trim() == '') {
        continue;
      }
      if (Object.prototype.hasOwnProperty.call(payload.areas, keyA)) {
        table3.objectives[keyA] = payload.areas[keyA];
        table3.objectives[keyA].products = [];
        table3.objectives[keyA].descriptions = [];
        table3.objectives[keyA].totalPrice = 0;
        table3.objectives[keyA].totalBenefit = 0;
        table3.objectives[keyA].coveragePercentage = 0;
        table3.objectives[keyA].priceAfterBenefit = 0
      }
    }

    const filteredBenefits: any = {};
    // filter incompatible benefits
    for (const key in payload.benefits) {
      if (Object.prototype.hasOwnProperty.call(payload.benefits, key)) {
        const benefit = payload.benefits[key];
        if (!benefit.incompatible_benefits || benefit.incompatible_benefits.length == 0 || benefit.incompatible_benefits == 0) {
          filteredBenefits[key] = benefit;
          continue;
        }
        const incompatibleBenefits = JSON.parse(benefit.incompatible_benefits);
        let toAdd = true;
        for (const incompatibleBenefit of incompatibleBenefits) {
          if (payload.benefits[incompatibleBenefit]) {
            const incompatibleBenefitObject = payload.benefits[incompatibleBenefit];
            if (incompatibleBenefitObject.benefit_value > benefit.benefit_value) {
              toAdd = false;
              break;
            }
          }
        }
        if (toAdd) {
          filteredBenefits[key] = benefit;
        }
      }
    }

    const objectiveMap: any = this.getObjectiveMap();

    // filter unique product ad arrange
    const filteredProducts: any = {};
    for (const key in payload.products) {
      if (!key || key.trim() == '') {
        continue;
      }
      if (Object.prototype.hasOwnProperty.call(payload.products, key)) {
        const productArray = payload.products[key].sort((a: any, b: any) => (objectiveMap[a.area_id].percentage < objectiveMap[b.area_id].percentage) ? 1 : -1);
        for (let i = 0; i < productArray.length; i++) {
          if (i == 0) {
            filteredProducts[key] = JSON.parse(JSON.stringify(productArray[i]));
            filteredProducts[key].area_id = [productArray[i].area_id];
            filteredProducts[key].suggestion_id = [productArray[i].suggestion_id];
            filteredProducts[key].descrizione_suggerimento = [productArray[i].descrizione_suggerimento];
            if (productArray[i].descrizione_azione?.trim().length > 0) {
              filteredProducts[key].descrizione_azione = [productArray[i].descrizione_azione];
            }
            if (productArray[i].benefit_id)
              filteredProducts[key].benefit_id = [productArray[i].benefit_id];
            // continue; // con il continue i prodotti vengono aggiunti su tutte le aree di obiettivo
            break; // con il break i prodotti vengono aggiunti solo sull'area con percentuale maggiore
          }
          const product = productArray[i];
          if (product.area_id && !filteredProducts[key].area_id.includes(product.area_id)) {
            filteredProducts[key].area_id.push(product.area_id);
          }
          if (product.suggestion_id && !filteredProducts[key].suggestion_id.includes(product.suggestion_id)) {
            filteredProducts[key].suggestion_id.push(product.suggestion_id);
          }
          if (product.descrizione_suggerimento && !filteredProducts[key].descrizione_suggerimento.includes(product.descrizione_suggerimento)) {
            filteredProducts[key].descrizione_suggerimento.push(product.descrizione_suggerimento);
          }
          if (product.descrizione_azione && product.descrizione_azione.trim().length > 0 && !filteredProducts[key].descrizione_azione.includes(product.descrizione_azione)) {
            filteredProducts[key].descrizione_azione.push(product.descrizione_azione);
          }
          if (product.benefit_id && !filteredProducts[key].benefit_id.includes(product.benefit_id)) {
            filteredProducts[key].benefit_id.push(product.benefit_id);
          }
        }
      }
    }

    const productsMap: any = {};
    // Step 1: Calcolo dell'investimento nominale (somma di tutti i prezzi dei prodotti)
    for (const keyA in payload.kpiList) {
      if (Object.prototype.hasOwnProperty.call(payload.kpiList, keyA)) {
        const area = payload.kpiList[keyA];
        areas.push(area);

        for (const key in area.products) {
          if (Object.prototype.hasOwnProperty.call(area.products, key)) {
            if (!key || key.trim() == '')
              continue;
            const product = area.products[key];
            // totalInvestment += parseFloat(product.product_price);
            // if (payload.products[product.product_id]) {
            //   payload.products[product.product_id].forEach((productOrig: any) => {
            //     if (table3.objectives[productOrig.area_id]) {
            //       table3.objectives[productOrig.area_id].products.push(productOrig);
            //       table3.objectives[productOrig.area_id].descriptions.push(productOrig.descrizione_azione);
            //       table3.objectives[productOrig.area_id].totalPrice += parseFloat(productOrig.product_price);

            //       if (productOrig.benefit_id && filteredBenefits[productOrig.benefit_id]) {
            //         table3.objectives[productOrig.area_id].totalPrice += parseFloat(filteredBenefits[productOrig.benefit_id].benefit_price);
            //         table3.objectives[productOrig.area_id].totalBenefit += parseFloat(filteredBenefits[productOrig.benefit_id].benefit_value);
            //       }
            //     }
            //   })
            // }
            if (filteredProducts[product.product_id]) {
              let productOrig = filteredProducts[product.product_id];
              productOrig.area_id.forEach((areaId: any) => {
                if (table3.objectives[areaId]) {
                  if (!table3.objectives[areaId].products.find((p: any) => p.product_id == productOrig.product_id)) {
                    table3.objectives[areaId].products.push(productOrig);
                    if (productOrig.descrizione_azione && productOrig.descrizione_azione.length > 0) {
                      table3.objectives[areaId].descriptions.push(productOrig.descrizione_azione);
                    }
                    table3.objectives[areaId].totalPrice += parseFloat(productOrig.product_price);
                    if (!productsMap[productOrig.product_id]) {
                      productsMap[productOrig.product_id] = {
                        product_id: 0,
                        product_price: 0,
                        benefit_price: 0,
                        benefit_value: 0
                      }
                    }
                    productsMap[productOrig.product_id].product_id = productOrig.product_id;
                    productsMap[productOrig.product_id].product_price = parseFloat(productOrig.product_price);

                    if (productOrig.benefit_id && productOrig.benefit_id.length > 0) {
                      productOrig.benefit_id.forEach((benefitId: any) => {
                        if (!filteredBenefits[benefitId]) {
                          return;
                        }
                        const filteredBenefit = filteredBenefits[benefitId];
                        table3.objectives[areaId].totalPrice += parseFloat(filteredBenefit.benefit_price);
                        table3.objectives[areaId].totalBenefit += parseFloat(filteredBenefit.benefit_value);
                        if (!productsMap[filteredBenefit.benefit_product_id]) {
                          productsMap[filteredBenefit.benefit_product_id] = {
                            product_id: 0,
                            product_price: 0,
                            benefit_price: 0,
                            benefit_value: 0
                          }
                        }
                        productsMap[filteredBenefit.benefit_product_id].product_id = productOrig.product_id;
                        productsMap[filteredBenefit.benefit_product_id].benefit_price = parseFloat(filteredBenefit.benefit_price);
                        productsMap[filteredBenefit.benefit_product_id].benefit_value = parseFloat(filteredBenefit.benefit_value);
                      })
                    }
                  }
                }
              })
            }
          }
        }
      }
    }

    for (const key in table3.objectives) {
      if (Object.prototype.hasOwnProperty.call(table3.objectives, key)) {
        if (!key || key.trim() == '')
          continue;
        if (table3.objectives[key].products.length == 0 || table3.objectives[key].totalPrice == 0) {
          delete table3.objectives[key];
          continue;
        }
        table3.objectives[key].coveragePercentage = table3.objectives[key].totalPrice ? (table3.objectives[key].totalBenefit / table3.objectives[key].totalPrice) * 100 : 0;
        table3.objectives[key].priceAfterBenefit = table3.objectives[key].totalPrice - table3.objectives[key].totalBenefit;
        // table3.realInvestment += table3.objectives[key].priceAfterBenefit;
        totalInvestment += table3.objectives[key].totalPrice ? parseFloat(table3.objectives[key].totalPrice) : 0;
      }
    }

    Object.values(productsMap).forEach((product: any) => {
      table3.realInvestment += parseFloat(product.product_price) + parseFloat(product.benefit_price) - parseFloat(product.benefit_value);
    })

    table3.totalInvestment = totalInvestment;

    table3.objectives = Object.values(table3.objectives);

    return table3;
  }

  arrangeTable4(payload: any) {
    let table4: any = {
      objectives: [],
      benefitSum: 0,
      realInvestment: this.table3 ? this.table3.realInvestment : 0,
      total: 0,
      competence: 0
    };

    const balanceData = payload.invAndBenefit.localFinancialStatements[0];

    const om: any = this.getObjectiveMap();
    for (const key in om) {
      if (!key || key.trim() == '') {
        continue;
      }
      if (Object.prototype.hasOwnProperty.call(om, key)) {

        if (!this.table3.objectives.find((x: any) => x.id == key)) {
          continue;
        }

        const area = om[key];

        if (!area.key || area.key.trim() == '') {
          continue;
        }

        let v = null;
        const keySplitted = area.key.split('.');
        v = balanceData[keySplitted[0]];
        if (keySplitted.length > 1) {
          for (let i = 1; i < keySplitted.length; i++) {
            v = v[keySplitted[i]];
          }
        }
        if(!v) {
          v = 0;
        }
        v = v * area.percentage / 100;
        table4.objectives.push({
          'name': area.obiettivoRaggiunto,
          'percentage': area.percentage,
          'value': v
        });

        table4.benefitSum += v;
      }
    }

    table4.total = table4.benefitSum - table4.realInvestment;
    table4.competence = table4.total * 0.10;

    return table4;
  }

  // calcBeneficio(product: any, benefitId: string, benefit: any, payload: any) {
  //   return 1000;
  // }


}
